import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_kejian",
  "use": "icon-icon_kejian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_kejian\"><path d=\"M50.404 512a469.504 469.504 0 0 1 923.192 0 469.504 469.504 0 0 1-923.192 0zM512 725.333a213.333 213.333 0 1 0 0-426.666 213.333 213.333 0 0 0 0 426.666zM512 640a128 128 0 1 1 0-256 128 128 0 0 1 0 256z\" fill=\"#ffca85\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol